import React, { useState } from 'react'
import AuthLayout from '../../shared/AuthLayout';
import Login from '../../forms/auth/Login';
import { useNavigate } from 'react-router-dom';
import useAuth from './../../../hooks/useAuth';
import { login } from '../../../services/auth';
import Message from './../../shared/Message';
import { createMessage } from '../../../utilities/utilities';
import { handleError} from '../../../utilities/errorHandler';

const LoginScreen = () => {
    const navigate = useNavigate();
    const {setAuth} = useAuth();

    const [isSaving, setIsSaving] = useState(false);

    const [message, setMessage] = useState({text: '', variant: '', show: false});

    const handleMessage = (text, variant) => {
        setMessage(createMessage(text, variant));
    }

    const onForgotPassword = () => {
        navigate('/forgot-password');
    }

    const handleCloseMessage = () => {
        setMessage((prevMessage) => ({...prevMessage, show: false}));
    }

    const userLogin = async (data) => {
        setIsSaving(true);

        try {
            const response = await login(data);
            handleMessage('You have successsfully signed in. Please wait while being redirected', 'success');
            
            setAuth({
                token: response?.data?.authorization?.token
            });
            setTimeout(() => {
                navigate('/');
            }, 1000);

            return true;
        } catch (error) {
            try {
                const errorMessage = handleError(error);
                if (errorMessage){
                    handleMessage(errorMessage.text, 'danger');
                }
            } catch(e){
                // error 422 will be handled by onSubmit() in Login.jsx 
                throw e;
            }
        } finally {
            await new Promise((resolve) => setTimeout(resolve, 500));
            setIsSaving(false);
        }
    }
  return (
    <AuthLayout
        title='Login'>
       {message.show && (
            <Message 
                message={message.text} 
                variant={message.variant} 
                show={message.show} 
                handleClose={handleCloseMessage} 
            />
        )}

        <Login 
            isSaving={isSaving}
            formAction={userLogin}
            onForgotPassword={onForgotPassword}
        />

    </AuthLayout>
  )
}

export default LoginScreen